import axios from 'axios';
import { md5Encrypt } from '@/utils/MD5.js';
import { BASE_URL, TIMEOUT } from '@/config/env.js';
import { getRequestParams, encodeToBase64 } from '@/utils/getPrams.js';


import router from '@/router/index.js';

// Create Axios instance
const service = axios.create({
  baseURL: BASE_URL,
  timeout: TIMEOUT
});

// Request interceptor
service.interceptors.request.use(
  (config) => {
    // Add timestamp header
    const beijingTime = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Shanghai' }));
    const formattedTime = `${beijingTime.getFullYear()}${String(beijingTime.getMonth() + 1).padStart(2, '0')}${String(beijingTime.getDate()).padStart(2, '0')}${String(beijingTime.getHours()).padStart(2, '0')}${String(beijingTime.getMinutes()).padStart(2, '0')}${String(beijingTime.getSeconds()).padStart(2, '0')}`;
    config.headers['X-TIMESTAMP'] = formattedTime;
    // Generate X-Sign header with MD5
    const dataToSign = config.method === 'get' ? config.params : config.data;
    const targetData = dataToSign ? dataToSign : {};
    const sortedData = Object.keys(targetData).sort().reduce((acc, key) => {
      acc[key] = targetData[key];
      return acc;
    }, {});
    const signStr = JSON.stringify(sortedData) + '95f9fa6d49v442add05f1c54d63749eda';
    config.headers['X-Sign'] = md5Encrypt(signStr);
    // Add sx-token header if token exists and is valid
    const token = localStorage.getItem('sx-token');
    if (token) {
      config.headers['sx-token'] = token;
    } else if (token) {
      // Token exists but is invalid, remove it
      console.error('Invalid token detected, removing from localStorage');
      localStorage.removeItem('sx-token');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
//console.log(res);

    // Handle error responses
    if (res.code === 10001 ) {
      // this.$message.error(res.message);
      handleTokenExpiry(res);
      return response;
    } else if (res.code !== 200 && res.message) {
      console.error('API Error:', res.message);
    }

    return response;
  },
  (error) => {
    // Handle network errors and HTTP error status codes
    // Check for 401 Unauthorized status code
    if (error.response && error.response.status === 401) {
      handleTokenExpiry();
      return Promise.reject(new Error('登录已过期，请重新登录'));
    }
    const errorMessage = error.response && error.response.status === 404 ? '请求错误，未找到该资源' : '网络错误';
    console.error('Network Error:', errorMessage);

    return Promise.reject(error);
  }
);

// 统一处理token过期逻辑
function handleTokenExpiry(res) {
  console.error('Token expired or invalid, redirecting to login...');

  // Clear local storage to ensure complete logout
  localStorage.removeItem('sx-token');
  localStorage.removeItem('isLoggedIn');

  // 使用setTimeout确保异步执行，避免阻塞
  setTimeout(() => {
    try {
      // 使用window.location.replace直接替换当前页面，绕过所有路由逻辑
      //console.log('Using window.location.replace to redirect to login');
      const urlParams = getRequestParams();
      window.location.replace('/login?' + urlParams);
    } catch (e) {
         const urlParams = getRequestParams();
      // 最后尝试：使用window.location.href
      console.error('Error during redirect, using window.location.href as last resort:', e);
      window.location.href = '/login?' + urlParams;
    }
  }, 100);
}

// HTTP methods
export function httpPost(url, data) {
  return service.post(url, data);
}

export function httpGet(url, params) {
  return service.get(url, { params });
}

export function httpDelete(url, params) {
  return service.delete(url, { params });
}

export function httpPut(url, data) {
  return service.put(url, data);
}

export function httpPatch(url, data) {
  return service.patch(url, data);
}

// Export default
export default service;
